const ActionTypes = {
  ACCESS_TOKEN_REQUEST: "ACCESS_TOKEN_REQUEST",
  ACCESS_TOKEN_SUCCESS: "ACCESS_TOKEN_SUCCESS",
  ACCESS_TOKEN_FAILURE: "ACCESS_TOKEN_FAILURE",

  RECEIVE_OTP_TOKEN: "RECEIVE_OTP_TOKEN",

  RESEND_OTP_REQUEST: "RESEND_OTP_REQUEST",
  RESEND_OTP_SUCCESS: "RESEND_OTP_SUCCESS",
  RESEND_OTP_FAILURE: "RESEND_OTP_FAILURE",

  VERIFY_OTP_REQUEST: "VERIFY_OTP_REQUEST",
  VERIFY_OTP_SUCCESS: "VERIFY_OTP_SUCCESS",
  VERIFY_OTP_FAILURE: "VERIFY_OTP_FAILURE",

  LOGOUT_REQUEST: "LOGOUT_REQUEST",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  LOGOUT_FAILURE: "LOGOUT_FAILURE",

  REFRESH_ACCESS_TOKEN_REQUEST: "REFRESH_ACCESS_TOKEN_REQUEST",
  REFRESH_ACCESS_TOKEN_SUCCESS: "REFRESH_ACCESS_TOKEN_SUCCESS",
  REFRESH_ACCESS_TOKEN_FAILURE: "REFRESH_ACCESS_TOKEN_FAILURE",

  FETCH_USER_REQUEST: "FETCH_USER_REQUEST",
  FETCH_USER_SUCCESS: "FETCH_USER_SUCCESS",
  FETCH_USER_FAILURE: "FETCH_USER_FAILURE",

  FETCH_ADMIN_LIST_REQUEST: "FETCH_ADMIN_LIST_REQUEST",
  FETCH_ADMIN_LIST_SUCCESS: "FETCH_ADMIN_LIST_SUCCESS",
  FETCH_ADMIN_LIST_FAILURE: "FETCH_ADMIN_LIST_FAILURE",

  FETCH_ADMIN_CREATE_REQUEST: "FETCH_ADMIN_CREATE_REQUEST",
  FETCH_ADMIN_CREATE_SUCCESS: "FETCH_ADMIN_CREATE_SUCCESS",
  FETCH_ADMIN_CREATE_FAILURE: "FETCH_ADMIN_CREATE_FAILURE",

  FETCH_ADMIN_UPDATE_REQUEST: "FETCH_ADMIN_UPDATE_REQUEST",
  FETCH_ADMIN_UPDATE_SUCCESS: "FETCH_ADMIN_UPDATE_SUCCESS",
  FETCH_ADMIN_UPDATE_FAILURE: "FETCH_ADMIN_UPDATE_FAILURE",

  FETCH_ADMIN_DELETE_REQUEST: "FETCH_ADMIN_DELETE_REQUEST",
  FETCH_ADMIN_DELETE_SUCCESS: "FETCH_ADMIN_DELETE_SUCCESS",
  FETCH_ADMIN_DELETE_FAILURE: "FETCH_ADMIN_DELETE_FAILURE",

  FETCH_ADMIN_DETAIL_REQUEST: "FETCH_ADMIN_DETAIL_REQUEST",
  FETCH_ADMIN_DETAIL_SUCCESS: "FETCH_ADMIN_DETAIL_SUCCESS",
  FETCH_ADMIN_DETAIL_FAILURE: "FETCH_ADMIN_DETAIL_FAILURE",

  /* Log */
  FETCH_LOGS_COUNT_REQUEST: 'FETCH_LOGS_COUNT_REQUEST',
  FETCH_LOGS_COUNT_SUCCESS: 'FETCH_LOGS_COUNT_SUCCESS',
  FETCH_LOGS_COUNT_FAILURE: 'FETCH_LOGS_COUNT_FAILURE',

  FETCH_LOGS_REQUEST: "FETCH_LOGS_REQUEST",
  FETCH_LOGS_SUCCESS: "FETCH_LOGS_SUCCESS",
  FETCH_LOGS_FAILURE: "FETCH_LOGS_FAILURE",  

  UPDATE_PASSWORD_REQUEST: "UPDATE_PASSWORD_REQUEST",
  UPDATE_PASSWORD_SUCCESS: "UPDATE_PASSWORD_SUCCESS",
  UPDATE_PASSWORD_FAILURE: "UPDATE_PASSWORD_FAILURE",

  FETCH_SYSTEM_INFO_REQUEST: "FETCH_SYSTEM_INFO_REQUEST",
  FETCH_SYSTEM_INFO_SUCCESS: "FETCH_SYSTEM_INFO_SUCCESS",
  FETCH_SYSTEM_INFO_FAILURE: "FETCH_SYSTEM_INFO_FAILURE",

  FETCH_USER_LIST_REQUEST: "FETCH_USER_LIST_REQUEST",
  FETCH_USER_LIST_SUCCESS: "FETCH_USER_LIST_SUCCESS",
  FETCH_USER_LIST_FAILURE: "FETCH_USER_LIST_FAILURE",

  FETCH_USER_CREATE_REQUEST: "FETCH_USER_CREATE_REQUEST",
  FETCH_USER_CREATE_SUCCESS: "FETCH_USER_CREATE_SUCCESS",
  FETCH_USER_CREATE_FAILURE: "FETCH_USER_CREATE_FAILURE",

  FETCH_USER_DETAIL_REQUEST: "FETCH_USER_DETAIL_REQUEST",
  FETCH_USER_DETAIL_SUCCESS: "FETCH_USER_DETAIL_SUCCESS",
  FETCH_USER_DETAIL_FAILURE: "FETCH_USER_DETAIL_FAILURE",

  FETCH_USER_UPDATE_REQUEST: "FETCH_USER_UPDATE_REQUEST",
  FETCH_USER_UPDATE_SUCCESS: "FETCH_USER_UPDATE_SUCCESS",
  FETCH_USER_UPDATE_FAILURE: "FETCH_USER_UPDATE_FAILURE",
};

export default ActionTypes;
